export const getBookCountLabel = (count: number): string => {
  if (count === 1) return 'książka';
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
    return 'książki';
  }
  return 'książek';
};

export const formatBookCountBadge = (count: number): string => {
  return `${count} ${getBookCountLabel(count)}`;
};

export const truncateBio = (bio: string | null, limit = 220): string | null => {
  if (!bio) return null;
  if (bio.length <= limit) return bio;
  return `${bio.substring(0, limit).trim()}…`;
};

export interface AuthorActionVisibility {
  showActions: boolean;
  showEditButton: boolean;
  showProfileButton: boolean;
}

export const getAuthorActionVisibility = (
  hasProfile: boolean,
  isAdmin: boolean
): AuthorActionVisibility => {
  return {
    showActions: hasProfile || isAdmin,
    showEditButton: isAdmin,
    showProfileButton: hasProfile,
  };
};

